<template>
  <div :class="isWebRedesign ? 'filter-option__redesign' : 'filter-option'">
    <button
      class="rhg-multiselect-chip"
      :class="option.selected && 'selected'"
      @click="onToggle"
      :disabled="option.matches === 0 || !showMatchesFilter"
    >
      <span v-if="iconBreakfast" :class="!isWebRedesign ? 'ml-1 mr-1' : ''">
        <img v-if="!isWebRedesign" :src="iconBR" alt="breakfast" width="15" />
        <i v-else-if="isWebRedesign" class="rhg-font-icon--coffee-tea-facilities"></i>
      </span>
      <span class="rhg-text-normal rhg-text-md rhg-multiselect-label">{{
        translate(option.label)
      }}</span>
      <span
        v-if="showNumberOfMatches"
        class="rhg-text-normal rhg-text-md rhg-multiselect-label ml-1"
        >({{ showMatchesFilter ? option.matches : 0 }})</span
      >
      <icon v-if="option.selected" class="close-chip rhg-font-icon--close"></icon>
    </button>
  </div>
</template>

<script>
import { assetsUrl } from '@/infrastructure/Configuration'

export default {
  name: 'FilterOptionComponent',
  props: {
    option: {
      type: Object
    },
    showNumberOfMatches: {
      type: Boolean,
      defaultValue: false
    },
    selectedRoomCode: {
      type: String
    },
    numberOfRoomsLeftByRoomId: {
      type: Array
    }
  },
  data: () => ({
    iconBR: `${assetsUrl}/svg/svg-icon/complimentary-coffee-and-tea.svg`
  }),
  computed: {
    iconBreakfast: function () {
      return this.option.code === 'breakfast'
    },
    showMatchesFilter() {
      const soldOutRooms = this.numberOfRoomsLeftByRoomId
        .filter(room => room.numberOfRoomsLeft === 0)
        .map(room => room.id)
      const isRoomSoldOut = this.option?.roomIds.some(roomId => soldOutRooms.includes(roomId))
      const isSelectedRoomIncluded = this.option?.roomIds.some(roomId => roomId === this.selectedRoomCode)

      return !isRoomSoldOut || isSelectedRoomIncluded
    }
  },
  methods: {
    onToggle() {
      this.option.selected ? this.$emit('unselect', this.option) : this.$emit('select', this.option)
    },
    isWebRedesign() {
      return (
        global.ConfigDynamic?.isEnabled({ key: 'web.redesign.0' }) &&
        global.ConfigDynamic?.isEnabled({ key: 'web.redesign.1' })
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-option {
  margin-right: 0.3rem;
}
.filter-option__redesign {
  margin-right: 16px;
}
</style>
